<script lang="ts">
  // types
  import type { PaymentTransferType } from "@shared/types/Invoice";

  // props
  export let payment: PaymentTransferType;

  const retailerName = () => {
    let name = "N/A";

    if (payment.retailer?.name) {
      name = payment.retailer.name;
    }

    if (payment.retailer_distributor?.account_number) {
      name += " (#" + payment.retailer_distributor.account_number + ")";
    }

    return name;
  };
</script>

<span>{retailerName()}</span>
